/* AJURA — Cinematic Scroll Animations
   Smooth fade-in + slide-up as sections enter the viewport.
   Uses GSAP (loaded via CDN) with IntersectionObserver for detection.
   Stagger animations for cards, steps, and grid items. */
(function () {
  'use strict';

  function init() {
    /* Skip Shopify editor to avoid conflicts with drag-and-drop */
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length || typeof IntersectionObserver === 'undefined') return;

    /* Set initial hidden state — skip hero (first), marquee, and trust badge sections */
    var animTargets = [];
    sections.forEach(function (el, i) {
      if (i === 0) return;
      if (el.querySelector('marquee-component')) return;
      if (el.querySelector('.ajura-trust')) return;
      el.style.opacity = '0';
      el.style.willChange = 'opacity, transform';
      animTargets.push(el);
    });

    /* Stagger child elements within a section for cinematic reveal */
    function animateChildren(section) {
      var selectors = [
        '.resource-list__item',
        '.testimonial-card',
        '.feature-item',
        '.process-step',
        '.faq-accordion__item',
        '.collection-card',
        '.brand-story__media',
        '.brand-story__content'
      ];
      var children = section.querySelectorAll(selectors.join(', '));
      if (!children.length || typeof gsap === 'undefined') return;

      gsap.fromTo(children, {
        opacity: 0,
        y: 24
      }, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: 'power3.out',
        clearProps: 'willChange'
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);

        if (typeof gsap !== 'undefined') {
          gsap.fromTo(el, {
            opacity: 0,
            y: 50
          }, {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: 'power3.out',
            clearProps: 'transform,willChange',
            onComplete: function () {
              animateChildren(el);
            }
          });
        } else {
          el.style.transition = 'opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }
      });
    }, {
      threshold: 0.06,
      rootMargin: '0px 0px -60px 0px'
    });

    animTargets.forEach(function (el) {
      observer.observe(el);
    });

    /* CSS class-based animations for elements with ajura-reveal etc. */
    var cssRevealSelectors = '.ajura-reveal, .ajura-reveal-stagger, .ajura-fade, .ajura-scale, .ajura-line-grow';
    var cssObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          cssObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll(cssRevealSelectors).forEach(function (el) {
      cssObserver.observe(el);
    });
  }

  /* Image blur-up: mark images as loaded for CSS reveal */
  function initImageReveal() {
    var images = document.querySelectorAll('.card-gallery img, .product-card img, .collection-card img, .media-with-content img, .brand-story img, .image-banner__image');
    images.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function () {
          img.classList.add('loaded');
        }, { once: true });
      }
    });
  }

  /* Run after page load so elements are sized correctly */
  if (document.readyState === 'complete') {
    init();
    initImageReveal();
  } else {
    window.addEventListener('load', function () {
      init();
      initImageReveal();
    });
  }
})();
